import React from "react";
import {
  FaAngular,
  FaCss3,
  FaHtml5,
  FaJsSquare,
  FaNode,
  FaReact,
} from "react-icons/fa";

const FeaturedSkills = () => {
  return (
    <div className="skills">
      <h1>&#60; featured skills /&#62;</h1>
      <ul >
        <section className="front-end">
          <h3>Front-end</h3>
          <li>
            HTML <FaHtml5 />
            CSS <FaCss3 />
            JavaScript <FaJsSquare />
          </li>
          <li>
            jQuery <FaJsSquare />
            EJS <FaJsSquare />
          </li>
          <li>
            Reactjs <FaReact />
            Angular <FaAngular />
          </li>
        </section>
        <section className="back-end">
          <h3>Back-end </h3>
          <li>
            Nodejs <FaNode />
          </li>
          <li>
            Expressjs <FaJsSquare />
          </li>
        </section>
        <section className="database">
          <h3>Database</h3>
          <li>SQL</li>
          <li>MongoDB</li>
          <li>Mongoose</li>
        </section>
      </ul>
    </div>
  );
};

export default FeaturedSkills;
